module.exports = __webpack_public_path__ + "static/img/yunyingmama_icon.d00d8d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/yunyingmama_icon.png
// module id = acpy
// module chunks = 1